import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import { AppService } from '../../../../services/app.service';
import { UtilitaryService } from '../../../../services/utilitary.service';

@Component({
  selector: 'kt-state-dialog',
  templateUrl: './state-dialog.component.html',
  styleUrls: ['./state-dialog.component.scss']
})
export class StateDialogComponent implements OnInit {

  states: any[];
  result: any = {
    id: "",
    selectedState: {}
  };
  constructor(
    public dialogRef: MatDialogRef<StateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private utilities: UtilitaryService
) { }

  ngOnInit() {
    this.result.id = this.data.id;
    this.states = this.data.transitions;
    this.utilities.log(this.data);
  }

}
